import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { navigate } from '@reach/router'
import moment from 'moment'
import View from './View'
import { getUserInfo } from '../../services/auth'
import { createApointment } from '../../services/booking'
import { colors } from '../Colors'
import VejaTambem from '../../components/VejaTambem'
import baby from '../../img/bebe-agendamento.jpg'

const Container = styled.section`
  width: 100%;
  margin-bottom: 2em;
  h2 {
    font-size: 30px !important;
    text-transform: capitalize;
    color: #fa7272;
    background: none;
    text-align: center;
    span {
      font-size: 16px;
      display: block;
      font-weight: normal;
    }
  }
  .pageHeader {
    margin: auto;
    width: 100%;
    display: block;
  }
  section.center {
    margin-top: 2em;
  }
  .buttons {
    width: 700px;
    margin: auto;
    text-align: center;
    button {
      margin: 20px;
    }
  }
  .agendamento {
    background: ${colors.vermelho};
    border-radius: 15px;
    width: 700px;
    margin: 0 auto 1em;
    color: #ffffff;
    display: flex;
    justify-content: space-between;
    overflow: hidden;
    box-shadow: 0px 10px 10px -10px rgba(0, 0, 0, 0.2);
    .detalhes {
      width: 70%;
    }
    img {
      height: 100%;
      width: 322px;
    }
    span {
      font-size: 12px;
      display: block;
      border-bottom: 1px solid rgba(256, 256, 256, 0.4);
      padding: 15px 45px;
      text-transform: uppercase;
      text-align: right;
      strong {
        font-size: 46px;
        text-transform: lowercase;
      }
      :last-child {
        border-bottom: none;
      }
    }
    .data {
      font-size: 23px;
    }
  }
`

const Detalhes = () => {
  const [data, setData] = useState([])
  const { convenio, time, day } = window.history.state
  const endTime = moment(time)
    .add(1, 'hour')
    .format('YYYY-MM-DD HH:MM:SS')

  useEffect(() => {
    async function fetchData() {
      const result = await getUserInfo()
      setData(result)
    }
    fetchData()
  }, [])

  const state = {
    convenio,
    time,
    day,
  }

  async function apointment() {
    const obj = {
      staff_id: '1',
      staff_any: '0',
      service_id: '1',
      start_date: time,
      end_date: endTime,
      created_from: 'rest api',
      customer_id: data.id,
      number_of_persons: '1',
      units: '1',
      status: 'approved',
      customer_appointment: {
        customer_id: '1',
      },
    }
    const response = await createApointment(obj)
      .then(result => {
        navigate('/agendamento-de-visitas/sucesso', {
          data,
        })
      })
      .catch(err => {
        alert('Um erro ocorreu, por favor tente novamente mais tarde.')
      })
  }

  return (
    <Container>
      <View>
        <p>Verifique a data e horário selecionados:</p>

        <section className="agendamento">
          <div className="detalhes">
            <span>{`${data.first_name} ${data.last_name}`}</span>
            <span className="data">
              <strong>{moment(time).format('DD [de] MMMM')}</strong>
              <br />
              {moment(time).format('YYYY')}
            </span>
            <span> {moment(time).format('dddd [às] HH[h]')}</span>
            <span>Visita à Maternidade Santa Joana</span>
          </div>
          <img src={baby} alt="Agendamento de visitas" />
        </section>
        <div className="buttons">
          <button
            type="button"
            onClick={() => navigate('/agendamento-de-visitas/calendario')}
            className="button prev"
          >
            Alterar a data
          </button>
          <button
            type="button"
            onClick={() =>
              navigate('/agendamento-de-visitas/horarios', {
                state,
              })
            }
            className="button prev"
          >
            Alterar o horário
          </button>
          <button
            type="button"
            onClick={() => apointment()}
            className="button next"
          >
            Concluir
          </button>
        </div>
      </View>
      <VejaTambem />
    </Container>
  )
}

export default Detalhes
